<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :style="iconSizeStyle(size)"
    viewBox="0 0 22 22"
    fill="none"
    aria-hidden="true"
    class="g-icon-link-broken"
  >
    <path
      d="M15 21V19C15 18.4477 15.4477 18 16 18C16.5523 18 17 18.4477 17 19V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21ZM4.36523 9.63574C4.75573 9.24549 5.38884 9.24543 5.7793 9.63574C6.16974 10.0262 6.16959 10.6593 5.7793 11.0498L4.66309 12.166C3.23535 13.5938 3.23535 15.9091 4.66309 17.3369C6.09089 18.7647 8.40615 18.7647 9.83398 17.3369L10.9502 16.2207C11.3407 15.8304 11.9738 15.8303 12.3643 16.2207C12.7547 16.6112 12.7546 17.2442 12.3643 17.6348L11.248 18.751C9.03916 20.9598 5.45788 20.9598 3.24902 18.751C1.04024 16.5421 1.04024 12.9608 3.24902 10.752L4.36523 9.63574ZM21 15C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H19C18.4477 17 18 16.5523 18 16C18 15.4477 18.4477 15 19 15H21ZM10.7051 3.2959C12.914 1.08732 16.4953 1.08712 18.7041 3.2959C20.9128 5.50468 20.9127 9.08604 18.7041 11.2949L17.6318 12.3672C17.2414 12.7577 16.6083 12.7576 16.2178 12.3672C15.8272 11.9767 15.8272 11.3436 16.2178 10.9531L17.2891 9.88086C18.7169 8.45303 18.7169 6.13779 17.2891 4.70996C15.8613 3.28266 13.5469 3.28258 12.1191 4.70996L11.0469 5.78223C10.6564 6.17275 10.0233 6.17275 9.63281 5.78223C9.24229 5.3917 9.24229 4.75869 9.63281 4.36816L10.7051 3.2959ZM3 5C3.55228 5 4 5.44772 4 6C4 6.55228 3.55228 7 3 7H1C0.447715 7 0 6.55228 0 6C0 5.44772 0.447715 5 1 5H3ZM5 3V1C5 0.447715 5.44772 0 6 0C6.55228 0 7 0.447715 7 1V3C7 3.55228 6.55228 4 6 4C5.44772 4 5 3.55228 5 3Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
import { iconSizeStyle } from '~/utils/iconSize'

withDefaults(defineProps<{ size?: number | string }>(), {
  size: 12
})
</script>

<style scoped>
.g-icon-link-broken {
  display: block;
  flex-shrink: 0;
  color: inherit;
}
</style>
